import type { AppCheck } from "firebase/app-check";

import { getWordinariusFirebaseApp } from "./firebaseApp";

export const VERIFIED_PUBLIC_APP_CHECK_SITE_KEY = "6Lfp78AtAAAAADs__vl5SpEBQK4QRUmeoGQQxmK_";

let appCheck: AppCheck | null = null;

let initialization: Promise<AppCheck | null> | null = null;

export function resolveAppCheckSiteKey(configuredValue: string | undefined): string {
  const configured = String(configuredValue || "").trim();
  if (configured && configured !== VERIFIED_PUBLIC_APP_CHECK_SITE_KEY) {
    throw new Error("firebase_app_check_site_key_mismatch");
  }
  return configured || VERIFIED_PUBLIC_APP_CHECK_SITE_KEY;
}

export function initializeWordinariusAppCheck(): Promise<AppCheck | null> {
  if (appCheck) return Promise.resolve(appCheck);
  const siteKey = resolveAppCheckSiteKey(import.meta.env.VITE_FIREBASE_APP_CHECK_SITE_KEY);
  const app = getWordinariusFirebaseApp();
  if (!app) return Promise.resolve(null);
  if (!initialization) {
    initialization = import("firebase/app-check").then(({ initializeAppCheck, ReCaptchaEnterpriseProvider }) => {
      appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(siteKey),
        isTokenAutoRefreshEnabled: true,
      });
      return appCheck;
    });
  }
  return initialization;
}
